import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendBenchmarkConfig, BackendQueryBenchmarkConfigArgs } from 'src/types/backend';

import { BENCHMARK_CONFIG_FRAGMENT } from './schema';

const QUERY = gql`
  query PerformanceCenterBenchmark($customerId: ID!, $assetType: AssetTypeEnum) {
    benchmarkConfig(customerId: $customerId, assetType: $assetType) {
      ...BenchmarkConfig
    }
  }
  ${BENCHMARK_CONFIG_FRAGMENT}
`;

type Variables = BackendQueryBenchmarkConfigArgs;
type Result = BackendBenchmarkConfig[];

export const queryPerformanceCenterBenchmark = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data);
};
